<template>
  <div class="dropdown" @click="isOpen = !isOpen">
    <button class="dropdown-button">
      <span class="dropdown-button-text font-rubik">{{ page.name }}</span>
      <span class="dropdown-arrow">
        <img
          :class="{ 'rotate-up': isOpen, 'rotate-down': !isOpen }"
          src="@/images/header/drop-down-arrow.svg"
          alt="Arrow"
          class="arrow-icon"
        />
      </span>
    </button>
    <ul v-if="isOpen" class="dropdown-menu">
      <li
        v-for="(page, index) in page.pages"
        :key="index"
        @click="selectItem()"
        class="dropdown-item"
      >
        <a class="item-link" :href="page.slug">
          {{ page.name }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Dropdown',
  props: {
    page: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    selectItem() {
      this.isOpen = false
    }
  }
}
</script>

<style scoped>
.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-button {
  background-color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.dropdown-button-text {
  color: black;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.0125em;
  margin-bottom: -5px;
}

.dropdown-arrow {
  margin-left: 8px;
  display: flex;
  align-items: center;
}

.arrow-icon {
  width: 24px;
  height: auto;
  transition: transform 0.3s ease;
}

.rotate-up {
  transform: rotate(180deg);
}

.rotate-down {
  transform: rotate(0deg);
}

.dropdown-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: -135px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  list-style-type: none;
  margin-top: 13px;
  padding-top: 5px;
  padding-bottom: 5px;
  width: 220px;
  z-index: 1000;
}

.dropdown:hover .dropdown-menu {
  display: block;
}

.dropdown-item {
  padding: 8px 16px;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
}

.item-link {
  color: black;
}
</style>
